import RestaurantIcon from './RestaurantIcon'

export default RestaurantIcon
